import Resource from '@/api/Resource';

export default class UserGroup extends Resource {
  $name = 'user-groups';

  $defaults() {
    return {
      id: null,
      system: 0,
      name: '',
      title: '',
    };
  }

  // get isManager() {
  //   return this.name === 'admin' || this.name === 'manager';
  // }
}
